import { type FC } from 'react';
import type { NodeProps } from 'reactflow';
import type { NodeData } from '@/types/node.types';
import BaseNode from './BaseNode';

const ACTIVITY_COLOR = '#22C55E';

export const ActivityNode: FC<NodeProps<NodeData>> = ({ id, data, selected }) => {
  return <BaseNode id={id} data={data} color={ACTIVITY_COLOR} icon={'\u26A1'} selected={selected} />;
};

export default ActivityNode;
